import { CTN, Stack } from '@zet/design-system'
import PDF from '@zet/svg/pdf'

const DocumentHandelling = ({ document }) => {
  return (
    <Stack className="border-grays-40  border-1 mr-2 h-[30] w-1/4 rounded-md p-2">
      <Stack>
        {/* <Icon type="Pdf" color="#50AB62" size={36} /> */}
        <PDF />
      </Stack>
      <Stack>
        <CTN numberOfLines={1} ellipsizeMode="tail">
          {document}
        </CTN>
      </Stack>
    </Stack>
  )
}

export default DocumentHandelling
